import { render, staticRenderFns } from "./BasePanel.vue?vue&type=template&id=16e2f530&scoped=true"
import script from "./BasePanel.vue?vue&type=script&lang=js"
export * from "./BasePanel.vue?vue&type=script&lang=js"
import style0 from "./BasePanel.vue?vue&type=style&index=0&id=16e2f530&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e2f530",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e2f530')) {
      api.createRecord('16e2f530', component.options)
    } else {
      api.reload('16e2f530', component.options)
    }
    module.hot.accept("./BasePanel.vue?vue&type=template&id=16e2f530&scoped=true", function () {
      api.rerender('16e2f530', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/panel/BasePanel.vue"
export default component.exports